/* eslint-disable */
import React from 'react'
import ReactDOM from 'react-dom'
import imageIconSpeaker from '../assets/images/icon-speaker.png'
import imageIconSpeakerInverted from '../assets/images/icon-speaker-inverted.png'
import platform from '../utils/platform'
import { parseContent } from '../utils/parser'
import dictionary from '../utils/dictionary'
import colors from '../utils/colors'
import { API_URL } from '../config'
import {
  Text,
  StyleSheet,
  View,
  TouchableWithoutFeedback,
  Image,
  ActivityIndicator,
  ScrollView,
} from 'react-native'

const styles = StyleSheet.create({
  text: {
    fontFamily: 'Cormorant Garamond, serif',
    fontSize: 26,
    lineHeight: '1.35',
  },
  
  selectionContainer: {
    marginBottom: 10,
    marginRight: 85,
    height: 41,
    justifyContent: 'center',
  },
  
  selection: {
    color: 'white',
    fontSize: 36,
    fontWeight: '600',
  },
  
  translation: {
    color: 'white',
    fontSize: 24,
    fontWeight: '600',
  },
  
  translationAdditionalLanguage: {
    color: 'white',
    fontSize: 24,
    fontWeight: '600',
  },
  
  star: {
    position: 'absolute',
    top: 7,
    right: 0,
    color: 'white',
    fontSize: 30,
    zIndex: 1,
  },
  
  speaker: {
    position: 'absolute',
    top: 10,
    right: 43,
    zIndex: 1,
  },
  
  sectionTriangle: {
    position: 'absolute',
    top: 2.5,
    left: 0,
    fontWeight: '600',
    fontSize: 24,
    color: 'white',
  },
  
  sectionTitleContainer: {
    paddingLeft: 15,
    paddingTop: 10,
    paddingBottom: 10,
  },
  
  sectionTitle: {
    fontWeight: '600',
    fontSize: 14,
    color: 'white',
  },
  
  sectionContent: {
    paddingLeft: 15,
  },
  
  sectionContentRow: {
    color: 'white',
    lineHeight: 18,
    marginBottom: 5,
  },
  
  activityIndicatorContainer: {
    borderTopWidth: 1,
    borderTopColor: '#444',
    height: 155,
    justifyContent: 'center',
    marginLeft: -16,
    marginRight: -16,
    paddingLeft: 16,
    paddingRight: 16,
  },
  
  dictionaryTop: {
    marginBottom: 15,
  },
  
  sectionsScroll: {
    borderTopWidth: 1,
    borderTopColor: '#444',
    height: 155,
    marginLeft: -16,
    marginRight: -16,
    paddingLeft: 16,
    paddingRight: 16,
  },
})

export default class TextView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showDictionary: false,
      translation: '',
      translationAdditionalLanguage: '',
      addedToDictionary: false,
      dataLoaded: false,
      audioUrl: '',
      sections: [],
      disableAddToDictionary: false,
    }
  }
  
  update(content, translation, addedToDictionary) {
    const element = ReactDOM.findDOMNode(this.textRef)
    if (!element) return

    element.querySelectorAll('.global__textview-tooltip').forEach((tooltip) => {
      tooltip.remove()
    })

    const selection = window.getSelection()

    if (selection && selection.toString().trim() && selection.rangeCount > 0) {
      const oRange = selection.getRangeAt(0)
      const parentRect = element.getBoundingClientRect()
      const oRect = oRange.getBoundingClientRect()
      const tooltip = document.createElement('div')
      const tooltipTranslation = document.createElement('div')
      const tooltipStar = document.createElement('div')
      
      tooltipTranslation.classList.add('global__textview-tooltip-translation')
      tooltipTranslation.innerHTML = translation
      this.setState({ translation })
      
      tooltipTranslation.addEventListener('mousedown', () => {
        this.restoreSelectionRangeAlways = false
        this.restoreSelectionRange = window.getSelection().getRangeAt(0)
      })
      
      tooltipTranslation.addEventListener('click', () => {
        this.setState({ showDictionary: true }, this.initTooltipDictionary)
        
        document.querySelectorAll('.global__textview-tooltip').forEach((tooltip) => {
          tooltip.remove()
        })
      })
      
      tooltipStar.classList.add('global__textview-tooltip-star')
      tooltipStar.innerHTML = addedToDictionary ? '★' : '☆'
      
      tooltip.classList.add('global__textview-tooltip')
      tooltip.appendChild(tooltipTranslation)
      
      if (this.props.enableAddToDictionary && translation != '…') {
        tooltipStar.addEventListener('click', () => {
          tooltipStar.innerHTML = tooltipStar.innerHTML == '☆' ? '★' : '☆'
          this.props.onAddToDictionary()
        })
        
        tooltip.appendChild(tooltipStar)
      }
      
      tooltip.style.top = (oRect.top - parentRect.top) + 'px'
      tooltip.style.left = oRect.height < 60
        ? ((oRect.left - parentRect.left) + oRect.width / 2) + 'px'
        : (oRect.width) + 'px'
        
      this.tooltipTop = tooltip.style.top
      this.tooltipLeft = tooltip.style.left
        
      element.appendChild(tooltip)
    }
  }

  componentDidUpdate() {
    const element = ReactDOM.findDOMNode(this.textRef)
    const selection = window.getSelection()
    
    if (selection && !selection.toString()) {
      element.querySelectorAll('.global__textview-tooltip').forEach((tooltip) => {
        tooltip.remove()
      })
    }
  }

  componentDidMount() {
    const element = ReactDOM.findDOMNode(this.textRef)
    element.classList.add('global__textview')

    this.selectionChangeListener = () => {
      if (this.restoreSelectionRange) {
        window.getSelection().addRange(this.restoreSelectionRange)
        !this.restoreSelectionRangeAlways && setTimeout(() => this.restoreSelectionRange = null, 100)
        return
      }
    
      this.setState({ showDictionary: false })
      element.querySelectorAll('.global__textview-tooltip').forEach((tooltip) => {
        tooltip.remove()
      })
      
      if (this.specialKeyPressed) return

      if (this.ignoreInitialSelection) {
        this.ignoreInitialSelection = false
        return
      }

      const selection = window.getSelection()
      if (selection && selection.toString().trim() && selection.rangeCount > 0) {
        const oRange = selection.getRangeAt(0)
        const selectionElement = selection.getRangeAt(0).startContainer.parentNode.parentNode

        if (element == selectionElement) {
          this.props.onUpdate({ selection: selection.toString().replace(/←|→|\n/g, '') })
        }
      }
    }

    document.addEventListener('selectionchange', this.selectionChangeListener)
  }

  componentWillUnmount() {
    document.removeEventListener('selectionchange', this.selectionChangeListener)
    document.removeEventListener('keydown', this.keydownEventListener)
    document.removeEventListener('keyup', this.keyupEventListener)
  }
  
  initTooltipDictionary() {
    const tooltip = ReactDOM.findDOMNode(this.tooltipDictionaryRef)
    tooltip.classList.add('global__textview-tooltip-dictionary')
    
    tooltip.addEventListener('mouseenter', () => {
      this.restoreSelectionRangeAlways = true
      this.restoreSelectionRange = window.getSelection().getRangeAt(0)
    })
    
    tooltip.addEventListener('mouseleave', () => {
      this.restoreSelectionRange = null
    })
    
    tooltip.style.top = this.tooltipTop
    tooltip.style.left = this.tooltipLeft
    
    this.setState({ disableAddToDictionary: this.props.type == 'translated' })
    this.fetchData(this.props.type, window.getSelection().toString().toLowerCase(), this.state.translation)
  }
  
  play() {
    const audio = document.createElement('audio')
    audio.src = this.state.audioUrl
    audio.autoplay = true
    audio.onended = () => audio.remove()
    
    document.body.appendChild(audio)
  }
  
  onAddToDictionary() {
    if (this.state.disableAddToDictionary) return
    
    dictionary.has(this.getLanguagePair(), this.state.selection)
      ? dictionary.remove(this.getLanguagePair(), this.state.selection)
      : dictionary.add(this.getLanguagePair(), this.state.selection, this.state.translation)
      
    this.setState({
      addedToDictionary: dictionary.has(this.getLanguagePair(), this.state.selection),
    })
  }
  
  getLanguagePair() {
    return `${this.props.settings.languages.original}-${this.props.settings.languages.translated}`
  }
  
  fetchData(type, selection, translation) {
    const from = type == 'original' ? this.props.settings.languages.original : this.props.settings.languages.translated
    const to = type == 'original' ? this.props.settings.languages.translated : this.props.settings.languages.original
    const additional = type == 'original' ? this.props.settings.languages.additional : ''
    
    this.setState({
      selection,
      translation,
      audioUrl: '',
      translationAdditionalLanguage: '',
      addedToDictionary: dictionary.has(this.getLanguagePair(), selection),
      dataLoaded: false,
    })
    
    fetch(`${API_URL}/translate?text=${selection}&translation=${translation}&from=${from}&to=${to}&additional=${additional}&extra=true`)
      .then(response => response.json())
      .then(response => {
        this.setState({
          dataLoaded: true,
          translationAdditionalLanguage: response.translationAdditionalLanguage.toLowerCase(),
          audioUrl: response.audioUrl,
          sections: response.sections,
        })
      })
  }
  
  toggleSection(index) {
    this.setState({
      sections: this.state.sections.map((section, sectionIndex) => ({
        ...section,
        expanded: index == sectionIndex ? !section.expanded : section.expanded
      }))
    })
  }
  
  setInnerHtml(ref, html) {
    const element = ReactDOM.findDOMNode(ref)
    element && (element.innerHTML = html)
  }

  render() {
    const nightModeEnabled = this.props.settings.nightModeEnabled
    const C = colors(this.props.settings.nightModeEnabled)
    
    return (
      <View ref={(ref) => this.textRef = ref}>
        <Text style={[styles.text, this.props.style]}>
          {this.props.children}
        </Text>
        
        {this.state.showDictionary && 
          <View ref={ref => this.tooltipDictionaryRef = ref}>
            <View style={styles.dictionaryTop}>
              <TouchableWithoutFeedback onPress={this.play.bind(this)}>
                <View style={[styles.speaker, this.state.audioUrl ? {} : {opacity: 0.5, cursor: 'default'}]}>
                  <Image source={this.props.settings.nightModeEnabled ? imageIconSpeakerInverted : imageIconSpeaker} style={{width: 29, height: 29}} />
                </View>
              </TouchableWithoutFeedback>
              
              <Text style={[styles.star, C.colorInverted, !this.state.disableAddToDictionary ? {} : {opacity: 0.5, cursor: 'default'}]} onPress={this.onAddToDictionary.bind(this)}>
                {this.state.addedToDictionary ? '★' : '☆'}
              </Text>
            
              <View style={styles.selectionContainer}>
                <Text style={[styles.selection, C.colorInverted]} adjustsFontSizeToFit={true} numberOfLines={1}>{this.state.selection}</Text>
              </View>
              
              <Text style={styles.translations}>
                <Text style={[styles.translation, C.colorInverted]}>{this.state.translation}</Text>
                {this.state.translationAdditionalLanguage &&
                  <Text style={[styles.translationAdditionalLanguage, C.colorInverted]}> • {this.state.translationAdditionalLanguage}</Text>
                }
              </Text>
            </View>
            
            {!this.state.dataLoaded &&
              <View style={styles.activityIndicatorContainer}>
                <ActivityIndicator size='small' color={this.props.settings.nightModeEnabled ? 'black' : 'white'} />
              </View>
            }
              
            {this.state.dataLoaded &&
            <ScrollView style={styles.sectionsScroll}>
              <View style={styles.sections}>
                {this.state.sections.map((section, index) => (
                  <View style={styles.section} key={index}>
                    <TouchableWithoutFeedback onPress={this.toggleSection.bind(this, index)}>
                      <View style={styles.sectionTitleContainer}>
                        <Text style={[styles.sectionTriangle, C.colorInverted]}>{section.expanded ? '▾' : '▸'}</Text>
                        <Text style={[styles.sectionTitle, C.colorInverted]}>{section.title}</Text>
                      </View>
                    </TouchableWithoutFeedback>
                    
                    {section.expanded &&
                      <View style={styles.sectionContent}>
                        {section.content.map((row, index) => (
                          <Text key={index} style={[styles.sectionContentRow, C.colorInverted]}
                                ref={ref => this.setInnerHtml(ref, row)}>
                          </Text>
                        ))}
                      </View>
                    }
                  </View>
                ))}
              </View>
            </ScrollView>
            }
          </View>
        }
      </View>
    )
  }
}
